var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73455 5.70531C4.33863 6.13391 3.66137 6.13391 3.26545 5.70531L0.354428 2.55404C-0.237222 1.91356 0.217049 0.875487 1.08898 0.875488L6.91102 0.875488C7.78295 0.875488 8.23722 1.91356 7.64557 2.55404L4.73455 5.70531Z",
    fill: "#2E3B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBreak);
export default __webpack_public_path__ + "static/media/top-break.a7f253fe0014c75a236526c7af2b2e3a.svg";
export { ForwardRef as ReactComponent };